// extracted by mini-css-extract-plugin
export var displayNone = "_oe-6";
export var imgContainer = "_oe-2";
export var overflowHidden = "_oe-3";
export var productInfoCardButtonContainer = "_oe-5";
export var productTitleText = "_oe-4";
export var rightArrow = "_oe-1";
export var rightArrowContainer = "_oe-0";